module.exports = __webpack_public_path__ + "static/media/default.82cd8a5f.png";